export {Session}

class Session {

    constructor() {
    }

    static get _dataMap(){

        if (window.__app_session == null) {
            window.tracer.debug("[d-5bca364] Initializing Page Settings Globally");
            window.__app_session = {};
        }

        return window.__app_session;
    }

    static set(name, value){

        if (value == null){
            return;
        }

        if (name == null || name.length === 0)
        {
            return;
        }

        Session._dataMap[name] = value;
        window.tracer.debug(`[d575093] Session Set: ${name} = ${value}`);
    }

    static get(name){

        if (name == null || name.length === 0)
        {
            return;
        }

        let value = Session._dataMap[name];

        if (value != null) {
            window.tracer.debug(`[d712891] ${name} retrieved with value of '${value}'`);
        }

        return value;
    }

    static remove(name){

        if (name == null || name.length === 0)
        {
            return;
        }

        Session._dataMap[name] = null;
    }

    static destroy(){
        console.debug("[d712891] Session items deleted. Initialized again.");
        window.__page_settings = {};
    }
}
